import { activeTabBar } from './active-path';
import utils from 'blue-utils';
import programUrl from '@config/program-url';
import { $toast } from "$use-in-vue/mint-ui/toast";
import { login } from '$assets/js/login';
import config from '@config'

import store from '@store';
const subMenuColor = `#ca9f75`;

//生成children-item
function getChildrenItem(opts = {}) {
  const { value, to, itemClassName = true } = opts;
  return {
    content: {
      value,
      fontSize: 14
    },
    link: {
      style: 'color:white;'
    },
    to,
    className: itemClassName ? 'bc-bd-b-white' : false
  };
}

//生成children
function getChildren(opts = {}) {
  const { items } = opts;
  const _items = [];
  utils.each(items, (item, index) => {
    _items.push(getChildrenItem({
      value: item.value,
      to: item.to,
      itemClassName: (index !== items.length - 1)
    }));
  });
  return {
    list: {
      items: _items,
      style: `border:1px solid white;border-radius:4px;`
    },
    arrow: {
      background: subMenuColor
    },
    style: `background:${subMenuColor};border-radius:4px;`
  }
}


//子菜单的icon属性
const subMenuIcon = {
  direction: 'left',
  style: 'font-size:7px;',
  // font: `iconfont iconsanhengxian1`,
  // activeFont: `iconfont iconsanhengxian1`
};

const homeTabBar = {
  list: {
    items: [
      {
        content: {
          value: '首页',
          fontSize: 16
        },
        className: 'bc-pd-tb-8',
        icon: {
          src:`${config.path.static}/img/home/home-nor.png`,
					activeSrc:`${config.path.static}/img/home/home-sel.png`,
          style: 'width:22px;height:22px;',
          direction: 'left'
        },
        // to: '/',
        to() {
          if(!store.getters.isLogin){
            login();
          }else {
            // location.href = `${programUrl['gou-wu-bao']}/home/index/main.html?mark=1`;
            location.href = `${programUrl['gou-wu-bao']}`;
          }
        }
      }/*,
      {
      content: {
        value: '一点百通',
        fontSize: 14
      },
      className: 'bc-pd-tb-7',
      icon: {
        src:`${config.path.static}/img/home/yi-no.png`,
        activeSrc:`${config.path.static}/img/home/yi-yes.png`,
        style: 'width:22px;height:22px;',
        direction: 'left'
      },
      to: '/'
    }*/,{
      content: {
        value: '个人中心',
        fontSize: 16
      },
      icon: {
        src:`${config.path.static}/img/home/my-nor.png`,
        activeSrc:`${config.path.static}/img/home/my-sel.png`,
        style: 'width:22px;height:22px;',
        direction: 'left'
      },
      to() {
        if(!store.getters.isLogin){
          login();
        }else {
          location.href = `${programUrl['gou-wu-bao']}/member`;
        }
      },
      /*children: getChildren({
        items: [{
          value: '我是学员',
          to(){
            if(!store.getters.isLogin){
              login();
            }else {
              this.$router.push('/students');
            }
          },
          /!*to: '/students'*!/
        }
        // , {
        //   value: '我是教练',
        //   to: '/'
        // }, {
        //   value: '我是分校',
        //   to: '/'
        // }
        , {
          value: '办公室',
          to(){
	          location.href = `${programUrl['gou-wu-bao']}/member`;
          }
        }]
      }),*/
      className: 'bc-pd-tb-8'
    }]
  },
  active() {
    this.activeIndex = activeTabBar()
  }
};

export default homeTabBar;
